// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

// components
import { StandardCalibrationListComponent } from './standard-calibration-list/standard-calibration-list.component';
import { StandardCalibrationComponent } from 'app/standards/standard-calibration/standard-calibration.component';

// modules
import { MaterialModule } from 'app/shared/material/material.module';
import { ComponentsModule } from 'app/shared/components/components.module';

// services
import { StandardService } from './shared/standard.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    ComponentsModule,
    TranslateModule,
    PdfJsViewerModule,
  ],
  exports: [
    StandardCalibrationListComponent,
    StandardCalibrationComponent
  ],
  declarations: [
    StandardCalibrationListComponent,
    StandardCalibrationComponent
  ],
  providers: [
    StandardService
  ]
})
export class StandardsModule { }



// WEBPACK FOOTER //
// ./src/app/standards/standards.module.ts